const ErrorMessage = () => {
  return <p>Something went wrong</p>;
};

export default ErrorMessage;
